import { render, staticRenderFns } from "./FixedCta.vue?vue&type=template&id=ac2a6d5c&scoped=true"
import script from "./FixedCta.js?vue&type=script&lang=js&external"
export * from "./FixedCta.js?vue&type=script&lang=js&external"
import style0 from "./FixedCta.scss?vue&type=style&index=0&id=ac2a6d5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2a6d5c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
